import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { ProductsDownloadTaskProcessorComponent } from './products-download-task-processor/products-download-task-processor.component';

@Component({
    selector: 'app-products-download',
    templateUrl: './products-download.component.html',
    styleUrls: ['./products-download.component.scss'],
    standalone: false
})
export class ProductsDownloadComponent implements OnInit, OnDestroy {

  ngOnDestroy(): void {
    if ( this.subscription != null ){
      this.subscription.unsubscribe();
    }
  }


  formInicial:UntypedFormGroup;
  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;
  debounceTime = 1000;
  available_filters: Object[];
  available_sorts: Object[];
  showSort: boolean;
  paging:Object = {};
  meliItens:Object[] = [];
  meliTempItens:Object[] = [];
  mktpmeli:Object[] = [];
  offset = 0;
  selectedCategories: Object[] = [];
  selectedOrder: Object[] = [];
  showFilter = false;
  codecompany;
  enableSearch = false;
  findById:boolean = false;
  updateMode:boolean = false;
  loadingMeli = false;


  constructor(private formBuilder:UntypedFormBuilder,
              private http:HTTPService,
              public uid:UserAuthenticationServices,
              private cd:ChangeDetectorRef,
              private dialogServices:DialogService) {

    this.formInicial = this.formBuilder.group({
      productSearch:new UntypedFormControl(),
    });


  }

  // Selecao de filtro por painel (substitui as mat-selection-list de selecao unica)
  toggleFilter(c: Object, d: Object) {
    this.offset = -1;
    this.meliItens = [];
    this.meliTempItens = [];

    const index = this.selectedCategories.findIndex(v => v['id'] == d['id'] && v['tipo'] == c);
    if (index >= 0) {
      this.selectedCategories.splice(index, 1);
    } else {
      // selecao unica por painel: remove qualquer outra opcao do mesmo filtro
      this.selectedCategories = this.selectedCategories.filter(v => v['tipo'] != c);
      this.selectedCategories.push({ name: d['name'], id: d['id'], results: d['results'], tipo: c });
    }
  }

  isFilterSelected(c: Object, d: Object): boolean {
    return this.selectedCategories.some(v => v['id'] == d['id'] && v['tipo'] == c);
  }

  isFilterPanelSelected(c: Object): boolean {
    return this.selectedCategories.some(v => v['tipo'] == c);
  }

  toggleSort(c: Object) {
    this.offset = -1;
    this.meliItens = [];
    this.meliTempItens = [];

    const index = this.selectedOrder.findIndex(v => v['id'] == c['id']);
    if (index >= 0) {
      this.selectedOrder.splice(index, 1);
    } else {
      // selecao unica de ordenacao
      this.selectedOrder = [];
      this.selectedOrder.push({ name: c['name'], id: c['id'] });
    }
  }

  isSortSelected(c: Object): boolean {
    return this.selectedOrder.some(v => v['id'] == c['id']);
  }

  inputChanged(){
    if ( !this.updateMode){
      this.modelChanged.next("alterado");
    }

  }

  limparBusca(){
    this.formInicial.get('productSearch').setValue('');
    this.inputChanged();
  }


  clearFilters(){
      this.offset = 0;
      this.meliItens = [];
      this.meliTempItens = [];
  }

  addItens(data:Object[]){
    if ( ObjectUtil.isNotEmpty(data)){

        data.forEach( item=>{

          if ( this.findById ){
              let newItem = item['body'];

              if (this.meliItens.indexOf(newItem) == -1 ){
                let id = newItem['id'];

                this.mktpmeli.forEach(value=>{
                  if ( value['MLB_ANUNCIO'] == id ){
                    newItem['hasproduct'] = true;
                    newItem['CODEMELI'] = value['CODEMELI'];
                    newItem['CODEPRODUCT'] = value['CODEPRODUCT'];
                    newItem['CODECOMPANY'] = value['CODECOMPANY'];
                    newItem['CODECONTRACT'] = value['CODECONTRACT'];
                  }
                })

                this.meliItens.push(newItem);
                this.meliTempItens.push(newItem);
              }

          }else{
            if (this.meliItens.indexOf(item) == -1 ){
              let id = item['id'];

              this.mktpmeli.forEach(value=>{
                if ( value['MLB_ANUNCIO'] == id ){
                    item['hasproduct'] = true;
                    item['CODEMELI'] = value['CODEMELI'];
                    item['CODEPRODUCT'] = value['CODEPRODUCT'];
                    item['CODECOMPANY'] = value['CODECOMPANY'];
                    item['CODECONTRACT'] = value['CODECONTRACT'];
                }
              })

              this.meliItens.push(item);
              this.meliTempItens.push(item);
            }
          }


        })


    }
  }

  selectProduct(data){

  }

  load(method:string, serviceName:string, params:Object[]){
    let ob = {
        codeCompany : this.codecompany,//this.uid.user.codecompany,
        method: method,
        serviceName: serviceName,
    }

    if ( params.length > 0 ){
      ob['params'] = params;
    }

    this.loadingMeli = true;

    let local = {
      entityName: 'Mktpmeli',
      showImageData:false,
      showImagaDataBase64:false,
      showPresentation:false,
      showRelationshipData:false,
      showRelationship:false,
      condition:"MLB_ANUNCIO IS NOT NULL",
    }

    this.http.post(local,'JsonBrokerServices/find',false,true,true).subscribe(result=>{

      this.mktpmeli = result['Mktpmeli'];

      this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(data=>{

          if ( this.findById ){
            this.addItens(data['resultado'] );
          }else{
            this.available_filters = data['resultado']['available_filters'];
            this.available_sorts = data['resultado']['available_sorts'];
            this.paging = data['resultado']['paging'];
            this.addItens(data['resultado']['results'] );
            if ( this.available_filters.length > 0 ){
              this.showFilter = true;
            }

            if ( this.available_sorts.length > 0 ){
              this.showSort = true;
            }

          }
          this.loadingMeli = false;
          this.cd.markForCheck();
      },
      (error)=>{
        this.loadingMeli = false;
        throw error;
      });
    },
    (error)=>{
      this.loadingMeli = false;
      throw error;
    })

  }

  enableFilters(){
    this.enableSearch=true;
    this.formInicial.get("productSearch").enable();
  }

  ngOnInit(): void {

    this.formInicial.get("productSearch").disable();
    this.subscription = this.modelChanged
        .pipe(
          debounceTime(this.debounceTime),
        )
        .subscribe(() => {
          this.clearFilters();
        });

        if ( this.uid.user.companylist.length == 1 ){
          this.codecompany = this.uid.user.codecompany;
          this.load("GET","FindProd",[]);
          this.enableSearch = true;
          this.formInicial.get("productSearch").enable();
        }


  }


  pesquisar(p:boolean){

    if ( !this.updateMode ){
      let params:Object[] = [];

      if ( this.selectedCategories.length > 0 ){
        this.criarFiltros(params);
        //this.offset = -1;
        //this.meliItens = [];
      }

      if ( this.selectedOrder.length > 0 ){
        this.criarOrder(params);
        //this.offset = -1;
        //this.meliItens = [];
      }

      if ( p ){

        this.offset = this.offset + 1;

        let ob = {
          key:'&offset',
          value: this.offset * 50
        }
        params.push(ob);

        this.findById = false;

        this.load("GET","FindProd",params);

      }else{
        this.selectedCategories = [];
        this.selectedOrder = [];
        this.clearFilters();
        let textToFind:string = this.formInicial.get('productSearch').value;

        if (  ObjectUtil.isNotEmpty(textToFind)){
          if ( textToFind.toUpperCase().startsWith("MLB")){
            let ob = {
              key:'?ids',
              value: `encodeString(${textToFind})`
            }

            params.push(ob);
            this.findById = true;
            this.load("GET","FindProdByIds",params);


          }else{

            let ob = {
              key:'&q',
              value: `encodeString(${this.formInicial.get('productSearch').value})`
            }
            params.push(ob);
            this.findById = false;
            this.load("GET","FindProd",params);
          }

        }else{
          //this.codecompany = this.uid.user.codecompany;
          this.load("GET","FindProd",[]);
          this.enableSearch = true;
          this.formInicial.get("productSearch").enable();
        }

      }
    }else{

      this.loadingMeli = true;
      let local = {
        entityName: 'Mktpmeli',
        showImageData:false,
        showImagaDataBase64:false,
        showPresentation:true,
        showRelationshipData:false,
        showRelationship:false,
        condition:"MLB_ANUNCIO IS NOT NULL AND CODECOMPANY="+this.codecompany
      }
      this.meliItens = [];
      this.meliTempItens = [];
      this.mktpmeli = [];

      this.http.post(local,'JsonBrokerServices/find',false,true,true).subscribe(result=>{
         this.mktpmeli = result['Mktpmeli'];
         this.paging['total'] = result['totalLines'];
         if ( this.mktpmeli.length > 0 ){
           this.mktpmeli.forEach(m=>{
              let ob = {
                ID:m['MLB_ANUNCIO'],
                NAME:m['TITLE'],
                CODEPRODUCT:m['CODEPRODUCT'],
                CODECOMPANY:m['CODECOMPANY'],
                CODECONTRACT:m['CODECONTRACT'],
                CODEMELI:m['CODEMELI'],
                DESCRPROD:m['FK__MKTPPRODUCTS->NAME'],
                checked:true
              }
              this.meliItens.push(ob)
              this.meliTempItens.push(ob);
           })

         }

      },error=>{
         this.loadingMeli = false;
         throw error;
      },()=>{
        this.loadingMeli = false;
      });
    }

  }

  changeMode(checked: boolean){
      this.updateMode = checked;

      this.meliItens = [];
      this.meliTempItens = [];
      this.paging['total'] = 0;
  }


  criarFiltros(params: Object[]) {
    let pa:{filterid:string,value:string}[] = [];

    this.selectedCategories.forEach(cat=>{
        let tipo:Object =  cat['tipo'];
        let filterid:string = tipo['id'];
        let id:string = cat['id'];
        if ( pa.find(fi=> fi.filterid == filterid)  != null ){
          pa.find(fi=> fi.filterid == filterid).value = id;
        }else{
          pa.push({filterid:filterid,value:id});
        }
    })

    if ( pa.length > 0 ){
      pa.forEach ( d =>{
        let f = params.find(x=>x['key'] == '&'+d.filterid );

        if ( f != null ){
          f['value'] = `encodeString(${d.value})`;
        }else{
          params.push({key:'&'+d.filterid, value:`encodeString(${d.value})`})
        }
      })

    }

  }

  selectChk(event,item){

  }

  criarOrder(params:Object[]){

    if ( this.selectedOrder.length > 0 ){
      this.selectedOrder.forEach(o=>{
        let f = params.find(x=>x['key'] == '&sort' );
        if ( f != null ){
          f['value'] = o['id'];
        }else{
          params.push({key:'&sort',value:o['id']});
        }

      });
    }
  }

  acaoAlterar(valor){
      this.meliItens.forEach(d=>{
          d['checked'] = valor;
      })

      this.meliTempItens.forEach(d=>{
        d['checked'] = valor;
    })
  }


  processar(){
    let filtered = this.meliItens.filter(d=>{return d['checked']  == true})
    if ( filtered.length > 0  )
      this.dialogServices.openGenericDialog(ProductsDownloadTaskProcessorComponent,filtered,(data)=>{

      },()=>{}, "400",null,true)
  }

  updateFilter(event){

    if ( this.updateMode ){
      const filterValue = (event.target as HTMLInputElement).value;

      this.meliTempItens= this.meliItens.filter((data: Object[]) => {

          let field:boolean = false;
          field =  (data['DESCRPROD'] ?? '').toString().toLowerCase().indexOf(filterValue.toLocaleLowerCase()) !== -1
          || (data['ID'] ?? '').toString().toLowerCase().indexOf(filterValue.toLocaleLowerCase()) !== -1
          || (data['CODEPRODUCT'] ?? '').toString().toLowerCase().indexOf(filterValue.toLocaleLowerCase()) !== -1


          return  field;
      });
    }

  }
}
